import { render, staticRenderFns } from "./ImportModals.vue?vue&type=template&id=0b00899c&"
import script from "./ImportModals.vue?vue&type=script&lang=js&"
export * from "./ImportModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports